import {RegistroEntrenador, RegistroEntrenadorJSON } from '../RegistroEntrenador/RegistroEntrenador';
import {Club, ClubJSON } from '../Club/Club';
import {Categoria, CategoriaJSON } from '../Categoria/Categoria';
export interface RegistroEntrenadorAntiguedadJSON {
    reanti_id: string;
    reanti_reid: string;
    reanti_clubid: string;
    reanti_catid: string;
    reanti_anio_desde: number;
    reanti_anio_hasta: number;
    reanti_tipo: string;
    club: ClubJSON | null;
    categoria: CategoriaJSON | null;
}

export class RegistroEntrenadorAntiguedad {
    protected constructor(
    private id: string,
    private reid: string,
    private clubid: string,
    private catid: string,
    private anioDesde: number,
    private anioHasta: number,
    private tipo: string,
    private club: Club | null,
    private categoria: Categoria | null) {}

    static createFrom( id: string,
    reid: string,
    clubid: string,
    catid: string,
    anioDesde: number,
    anioHasta: number,
    tipo: string,
    club: Club | null,
    categoria: Categoria | null) {
        return new this( id,
        reid,
        clubid,
        catid,
        anioDesde,
        anioHasta,
        tipo,
        club,
        categoria)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: RegistroEntrenadorAntiguedad) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: RegistroEntrenadorAntiguedadJSON) {
        return RegistroEntrenadorAntiguedad.createFrom( entity.reanti_id,
        entity.reanti_reid,
        entity.reanti_clubid,
        entity.reanti_catid,
        entity.reanti_anio_desde,
        entity.reanti_anio_hasta,
        entity.reanti_tipo,
        entity.club ? Club.fromJSON(entity.club) : null,
        entity.categoria ? Categoria.fromJSON(entity.categoria) : null)
    }

    toJSON(): RegistroEntrenadorAntiguedadJSON {
        return {
            reanti_id: this.getId(),
            reanti_reid: this.getReid(),
            reanti_clubid: this.getClubid(),
            reanti_catid: this.getCatid(),
            reanti_anio_desde: this.getAnioDesde(),
            reanti_anio_hasta: this.getAnioHasta(),
            reanti_tipo: this.getTipo(),
            club: this.getClub() ? this.getClub()!.toJSON() : null,
            categoria: this.getCategoria() ? this.getCategoria()!.toJSON() : null
        }

    }

    getId(): string { return this.id; }

    getReid(): string { return this.reid; }

    getClubid(): string { return this.clubid; }

    getCatid(): string { return this.catid; }

    getAnioDesde(): number { return this.anioDesde; }

    getAnioHasta(): number { return this.anioHasta; }

    getTipo(): string { return this.tipo; }

    getClub(): Club | null{ return this.club; }getCategoria(): Categoria | null{ return this.categoria; }

}

